import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { pageColors } from "../../mock";
import { useCart } from "../../context/CartContext";
import { PhotoGallery } from "../../components/PhotoGallery";
import { ArrowLeft, ShoppingBag, Check } from "lucide-react";

const PRICE = 850;
const PHOTOS = ["/img/supjack.png"];

const Supreme = () => {
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [added, setAdded] = useState(false);
  const [sold, setSold] = useState(false);

  useEffect(() => { document.title = "TMM|SUPREME"; }, []);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/bodega/status`)
      .then((r) => r.json())
      .then((d) => setSold(!!(d.items || []).find((i) => i.id === "sup-jacket-s")?.sold))
      .catch(() => {});
  }, []);

  const preorder = () => {
    addItem({
      id: "sup-jacket-s",
      name: "Supreme x B.B. Simon Studded Puffer Jacket — size S",
      price: PRICE,
      image: "/img/supjack.png",
      description: "Supreme x B.B. Simon studded puffer jacket — white.",
      tag: "supreme",
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1600);
  };

  return (
    <>
      <Header hoverColor={pageColors.fashion} compact={false} />
      <div className="brand-page">
        <button className="feed-back" onClick={() => navigate("/brands/mjs-bodega")} data-testid="supreme-back">
          <ArrowLeft size={16} /> Back to MJ's Bodega
        </button>

        <header className="brand-hero-center" data-testid="supreme-hero">
          <img src="/img/sup_mark.webp" alt="Supreme" className="brand-hero-mark sup" />
        </header>

        <section className="brand-preorder-preview supreme-preview" data-testid="supreme-preview">
          <PhotoGallery images={PHOTOS} alt="Supreme studded puffer jacket" testId="supreme-gallery" />
        </section>

        <section className="brand-preorder-panel" data-testid="supreme-preorder-panel">
          <div className="brand-preorder-name">Supreme x B.B. Simon Studded Puffer Jacket</div>
          <div className="brand-preorder-color" data-testid="supreme-color">Color — White</div>
          <div className="brand-preorder-price" data-testid="supreme-price">${PRICE}</div>
          {sold && <div className="bodega-sold-badge" data-testid="supreme-sold-badge">SOLD</div>}

          <div className="brand-size-block">
            <div className="brand-size-label">Size</div>
            <div className="brand-size-row" role="radiogroup" aria-label="Select size">
              <button
                type="button"
                role="radio"
                aria-checked="true"
                className="brand-size-chip active"
                data-testid="supreme-size-S"
              >
                S
              </button>
            </div>
          </div>

          <button
            type="button"
            className="btn-solid btn-huge"
            onClick={preorder}
            disabled={sold}
            data-testid="supreme-preorder-btn"
          >
            {sold ? (
              "SOLD OUT"
            ) : added ? (
              <>
                <Check size={18} /> Added — size S
              </>
            ) : (
              <>
                <ShoppingBag size={18} /> Add to cart — size S
              </>
            )}
          </button>
        </section>
      </div>
    </>
  );
};

export default Supreme;
